import {
  Boxes,
  Cpu,
  MessagesSquare,
  Send,
  FlaskConical,
  ScanSearch,
  Code2,
} from "lucide-react";

// The service registry. Order here is the order in the navigation, on the home
// page grid and in the footer. Changing the order is a one-line edit.
//
// Copy for each service lives in src/i18n/<lang>.json under services.<slug>.
// Nothing user-visible is hardcoded in this file.
//
// Icons are a placeholder set; the design agent may swap them or drop icons
// entirely. Keep the keys.

export const SERVICES = [
  { slug: "models", icon: Boxes, flagship: true },
  { slug: "generation", icon: Cpu, flagship: true },
  { slug: "llm", icon: MessagesSquare },
  { slug: "telegram", icon: Send },
  { slug: "growth", icon: FlaskConical },
  { slug: "audits", icon: ScanSearch },
  { slug: "development", icon: Code2 },
];

export const SERVICE_SLUGS = SERVICES.map((s) => s.slug);

export function getService(slug) {
  return SERVICES.find((s) => s.slug === slug) || null;
}
